<template>
  <div>
    <el-card
      class="box-card"
      shadow="never"
    >
      <div
        slot="header"
        class="card-header"
      >
        <span>图片管理</span>
        <el-button
          type="primary"
          size="small"
          plain
          @click="imageVisible = true"
        >
          编辑图片
        </el-button>
      </div>
      <div>
        <div
          v-if="image"
          class="image-box"
        >
          <div
            v-if="image"
            class="item"
          >
            <el-image
              style="width: 100px; height: 100px"
              :src="image.image_url"
              :preview-src-list="[image.image_url]"
              :z-index="9999"
            />
          </div>
        </div>
        <div
          v-else
          class="meter-text"
        >
          请选则图片
        </div>
      </div>
    </el-card>
    <!-- 选择图片 -->
    <ImageSelect
      :image-visible="imageVisible"
      :choose-one="true"
      @closeImageDialog="closeImageDialog"
      @chooseImage="chooseImage"
    />
  </div>
</template>

<script>
import ImageSelect from '@/components/imageSelect'
export default {
  components: {
    ImageSelect
  },
  model: {
    prop: 'image',
    event: 'imageChange'
  },
  props: {
    image: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      imageVisible: false
    }
  },
  methods: {
    closeImageDialog () {
      this.imageVisible = false
    },
    // 选择图片
    chooseImage (selectdata) {
      let image = selectdata[0]
      this.imageVisible = false
      this.$emit('imageChange', image)
    }
  }
}
</script>

<style lang="scss" scoped>
.image-box {
  overflow: hidden;
  zoom: 1;
  margin-right: -12px;
  .item {
    width: 95px;
    height: 95px;
    float: left;
    margin-right: 8px;
    margin-bottom: 10px;
    position: relative;
    &:last-child {
      margin-right: 0;
    }
    .num {
      position: absolute;
      left: 0;
      top: 0;
      width: 16px;
      height: 16px;
      background: rgba(0, 0, 0, 0.25);
      text-align: center;
      line-height: 16px;
      color: #fff;
      font-size: 12px;
    }
    .delete {
      position: absolute;
      right: 0;
      top: 0;
      width: 16px;
      height: 16px;
      background: #1890ff;
      text-align: center;
      line-height: 16px;
      color: #fff;
      font-size: 12px;
      cursor: pointer;
      opacity: 0;
    }
    .detail {
      position: absolute;
      left: 50%;
      top: 50%;
      width: 16px;
      height: 16px;
      margin: -8px 0 0 -8px;
      background: #1890ff;
      text-align: center;
      line-height: 16px;
      color: #fff;
      font-size: 12px;
      opacity: 0;
      cursor: pointer;
    }
    img {
      width: 95px;
      height: 95px;
    }
    &:hover {
      .delete,
      .detail {
        opacity: 1;
      }
    }
  }
}
.meter-text {
  font-size: 12px;
  color: #999;
  line-height: 20px;
  margin-bottom: 12px;
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

::v-deep {
  .el-card__header {
    padding: 5px 20px;
  }
}
.box-card {
  margin-bottom: 20px;
}
</style>
